import { css, cx } from "@emotion/css"
import React from "react"

import { css as cssFn } from "@emotion/react"
import LoadingOverlay from "@p-ban/common/src/components/overlay/LoadingOverlay/LoadingOverlay"

import COLOR_CODE from "../../../constant/color"

const graySpinnerStyle = cssFn`
  filter: brightness(0) saturate(100%) invert(50%);
`

type Props = {
  isLoading?: boolean
  head?: React.ReactElement
  mapChildren?: boolean
  children?: React.ReactNode
}

const ColumnTemplate = ({ isLoading = false, head, children, mapChildren = false }: Props) => {
  return (
    <div className={cx(styles.container, !head && styles.noHead)}>
      {head && <div className={styles.head}>{head}</div>}
      <div className={styles.contents}>
        {isLoading && <LoadingOverlay theme="light" spinnerStyle={graySpinnerStyle} />}
        {mapChildren
          ? React.Children.toArray(children).map((child, i) => (
              <div key={i} className={styles.cell}>
                {child}
              </div>
            ))
          : children}
      </div>
    </div>
  )
}

export default ColumnTemplate

const styles = {
  container: css`
    width: 140px;
    border-right: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
    border-left: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  noHead: css`
    margin-top: 80px;
  `,
  head: css`
    height: 80px;
    border-top: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  contents: css`
    position: relative;
    height: 335px;
    border-top: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
    border-bottom: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
  `,
  cell: css`
    height: 64px;
    border-bottom: 1px solid ${COLOR_CODE.SIMULATION_BORDER_GRAY};
    :last-child {
      height: 79px;
      border-bottom: none;
    }
  `,
}
